// Calibración del sensor de combustible del equipo (opcional). Medido en
// producción el 16-oct-2026: de ~20 equipos con combustible, muchos mandan
// unidades crudas (157, 6500) en vez de %, y la regla 0–100 de la bitácora los
// descarta. Con el valor crudo de tanque vacío y de tanque lleno el backend los
// convierte a %. Se guarda como device.fuel_sensor.

export type FuelSensor = { param: string; empty_raw: number; full_raw: number };
export type FuelSensorInput = { param?: string; empty_raw?: number | string | null; full_raw?: number | string | null };

const toNum = (v: unknown): number | undefined => {
  if (v == null || String(v).trim() === "") return undefined;
  const n = Number(String(v).trim().replace(",", "."));
  return Number.isFinite(n) ? n : NaN;
};

// Vacío → undefined (react-hook-form no lo manda); texto → número.
export const rawValue = (v: unknown) => toNum(v);

export const isFuelSensorEmpty = (s: FuelSensorInput | null | undefined) =>
  !s || (!(s.param ?? "").trim() && toNum(s.empty_raw) === undefined && toNum(s.full_raw) === undefined);

// Errores por campo; sección vacía = sin calibración, válido.
export const fuelSensorErrors = (s: FuelSensorInput | null | undefined) => {
  const errors: Partial<Record<keyof FuelSensor, string>> = {};
  if (isFuelSensorEmpty(s)) return errors;
  const empty = toNum(s!.empty_raw);
  const full = toNum(s!.full_raw);
  if (!(s!.param ?? "").trim()) errors.param = "Indica el parámetro del sensor";
  if (empty === undefined || Number.isNaN(empty)) errors.empty_raw = "Indica el valor con tanque vacío";
  if (full === undefined || Number.isNaN(full)) errors.full_raw = "Indica el valor con tanque lleno";
  else if (empty !== undefined && !Number.isNaN(empty) && full === empty) errors.full_raw = "Debe ser distinto del valor con tanque vacío";
  return errors;
};

// Lo que se manda en PUT /device (fuel_sensor): el objeto si se capturó; null
// si se vació y el equipo ya tenía calibración (el backend la quita con null);
// undefined (no se manda) si nunca tuvo.
export const fuelSensorPayload = (s: FuelSensorInput | null | undefined, hadOne: boolean): FuelSensor | null | undefined =>
  isFuelSensorEmpty(s)
    ? hadOne
      ? null
      : undefined
    : { param: (s!.param ?? "").trim(), empty_raw: toNum(s!.empty_raw)!, full_raw: toNum(s!.full_raw)! };
